module.exports = __webpack_public_path__ + "img/work-devstack.166efe50.png";